import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "2gnBNh",
    defaultMessage: "Edit price — {productName}",
    description: "order line price/discount dialog title",
  },
  menuItem: {
    id: "vZSYlO",
    defaultMessage: "Edit price / discount",
    description: "order line row menu item",
  },
  modePrice: {
    id: "UmOMcO",
    defaultMessage: "Unit price",
    description: "set a new unit price for the order line",
  },
  modePercentage: {
    id: "uMtukC",
    defaultMessage: "Discount %",
    description: "set a percentage discount for the order line",
  },
  originalPrice: {
    id: "sR9AWm",
    defaultMessage: "Original unit price: {price}",
    description: "undiscounted unit price of the order line",
  },
  newPriceLabel: {
    id: "5TFXHL",
    defaultMessage: "New unit price",
    description: "input label",
  },
  percentageLabel: {
    id: "kp1FsB",
    defaultMessage: "Discount",
    description: "percentage input label",
  },
  reasonLabel: {
    id: "fEHWzg",
    defaultMessage: "Reason (optional)",
    description: "discount reason input label",
  },
  resultingPrice: {
    id: "xjTb3K",
    defaultMessage: "Resulting unit price: {price} · line total: {total}",
    description: "preview of the discounted order line price",
  },
  hint: {
    id: "GHJ+B9",
    defaultMessage:
      "Applies to this order only; the product price is not changed. The price cannot be higher than the original one.",
    description: "order line price dialog hint",
  },
  priceTooHigh: {
    id: "lpHKVN",
    defaultMessage: "Must be between 0 and the original price",
    description: "order line price validation error",
  },
  percentageInvalid: {
    id: "3hjPn4",
    defaultMessage: "Must be between 0 and 100",
    description: "order line percentage validation error",
  },
});
